function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function renderTable(table) {
  const head = table.columns.map((column) => `<th>${escapeHtml(column)}</th>`).join("");
  const body = table.rows
    .map(
      (row) =>
        `<tr>${row.map((cell) => `<td>${escapeHtml(cell)}</td>`).join("")}</tr>`
    )
    .join("");

  return `
    <section class="block">
      <h2>${escapeHtml(table.title)}</h2>
      <table>
        <thead><tr>${head}</tr></thead>
        <tbody>${body}</tbody>
      </table>
    </section>
  `;
}

export function printReport({ title, subtitle = "", summary = [], tables = [] }) {
  const printable = window.open("", "_blank", "noopener,noreferrer,width=1200,height=900");
  if (!printable) return;

  const summaryHtml = summary.length
    ? `<section class="summary">${summary
        .map(
          (item) => `
            <div class="summary-card">
              <div class="summary-label">${escapeHtml(item.label)}</div>
              <div class="summary-value">${escapeHtml(item.value)}</div>
            </div>
          `
        )
        .join("")}</section>`
    : "";

  printable.document.write(`
    <html>
      <head>
        <title>${escapeHtml(title)}</title>
        <style>
          body { font-family: Arial, sans-serif; color: #0f172a; padding: 24px; }
          h1 { margin: 0; font-size: 28px; }
          .subtitle { color: #475569; margin: 8px 0 24px; }
          .summary { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; margin-bottom: 24px; }
          .summary-card { border: 1px solid #cbd5e1; border-radius: 12px; padding: 12px; }
          .summary-label { color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.08em; }
          .summary-value { font-size: 20px; font-weight: 700; margin-top: 6px; }
          .block { margin-top: 24px; }
          h2 { font-size: 18px; margin: 0 0 12px; }
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #cbd5e1; padding: 8px 10px; text-align: left; font-size: 12px; }
          th { background: #f8fafc; text-transform: uppercase; letter-spacing: 0.06em; font-size: 11px; }
        </style>
      </head>
      <body>
        <h1>${escapeHtml(title)}</h1>
        <div class="subtitle">${escapeHtml(subtitle)}</div>
        ${summaryHtml}
        ${tables.map(renderTable).join("")}
        <script>setTimeout(() => window.print(), 300)</script>
      </body>
    </html>
  `);
  printable.document.close();
  printable.focus();
}
